import UploadBox from "../../../exam/components/atoms/UploadBox";
import TextEditor from "../../../exam/components/atoms/TextEditor";
import SubmitButton from "../../../exam/components/atoms/SubmitButton";
import { useState } from "react";

export const ExamPage = () => {
  const [text, setText] = useState("");

  return (
    <div className="flex justify-center w-full p-6 bg-gray-50">
      <div className="w-full max-w-4xl p-6 bg-white rounded-lg shadow-md">
        <div className="mb-6">
          <label className="block mb-2 font-semibold text-gray-700 text-lg">
            Exam
          </label>
          <UploadBox />
        </div>
        <div className="mb-6">
          <label className="block mb-2 font-semibold text-gray-700 text-lg">
            Use case
          </label>
          <TextEditor value={text} onChange={setText} />
        </div>
        <div className="flex justify-end">
          <SubmitButton />
        </div>
      </div>
    </div>
  );
};
